
export default {
  name: 'VehicleHeadlightExclusionButton',
  props: {
    excluded: {
      type: Boolean,
      default: false,
    },
    pending: {
      type: Boolean,
      default: false,
    },
    failed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      if (this.failed) {
        return this.$t('components.vehicleHeadlightExclusionButton.failed')
      }
      return this.excluded
        ? this.$t('components.vehicleHeadlightExclusionButton.restore')
        : this.$t('components.vehicleHeadlightExclusionButton.exclude')
    },
    hint() {
      return this.excluded
        ? this.$t('components.vehicleHeadlightExclusionButton.restoreHint')
        : this.$t('components.vehicleHeadlightExclusionButton.excludeHint')
    },
  },
}
